var React = require('react');

function Features (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.583 12.771H7.417a.75.75 0 100 1.5h9.166a.75.75 0 100-1.5zm0-4.708H7.417a.75.75 0 100 1.5h9.166a.75.75 0 100-1.5zM13.183 22H5.015A1.014 1.014 0 014 20.986V3.017C4 2.456 4.455 2 5.018 2h13.996c.545 0 .986.442.986.986v12.196L13.183 22z","fillRule":"evenodd"}));
}

Features.defaultProps = {"width":"24","height":"24"};

module.exports = Features;

Features.default = Features;
